export default "__VITE_PUBLIC_ASSET__55fa60d6__"